import { render } from "./CapabilityTab.vue?vue&type=template&id=f2270dee&scoped=true"
import script from "./CapabilityTab.vue?vue&type=script&lang=js"
export * from "./CapabilityTab.vue?vue&type=script&lang=js"

import "./CapabilityTab.vue?vue&type=style&index=0&id=f2270dee&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2270dee"]])

export default __exports__